import KpiCard from './KpiCard.jsx';
import { SCORE_UNIT, scorePercent, secureScorePoints } from '../lib/score-format.js';

// The two score KPI cards Overview and Security both show (ENTRAID-347, product owner 2026-10-23): one component per
// card, so the number, the unit and the caption render the same markup on both pages. The pages pass only what
// differs: the link (Overview's cards open Security) and the caption of the onGuard score (its trend).

const finite = (n) => typeof n === 'number' && Number.isFinite(n);

/** The onGuard score card: the whole-number percent and the donut. */
export function OnguardScoreKpi({ score, caption, to, ariaLabel }) {
  const value = scorePercent(score);
  return (
    <KpiCard
      label="onGuard score"
      kpi="onGuard score"
      to={to}
      ariaLabel={ariaLabel}
      value={value}
      unit={SCORE_UNIT}
      variant="donut"
      percent={value}
      caption={value != null ? caption : 'Pending analysis'}
    />
  );
}

/** The Microsoft Secure Score card: the whole-number percent on the tile, the precise points in the caption. */
export function SecureScoreKpi({ msScore, to, ariaLabel }) {
  const pct = finite(msScore?.percentage) ? msScore.percentage : null;
  const points = secureScorePoints(msScore);
  return (
    <KpiCard
      label="Microsoft Secure Score"
      kpi="Secure Score"
      to={to}
      ariaLabel={ariaLabel}
      value={scorePercent(pct)}
      unit={SCORE_UNIT}
      variant="bar"
      percent={pct}
      caption={points ? `${points}, Microsoft Graph` : 'Not collected yet'}
    />
  );
}
